function TrackForm({ value, onChange, onSubmit, loading, errorMsg }) {
    return (
        <form onSubmit={onSubmit}>
            <input
                type="text"
                className="track-input"
                placeholder="Order ID / Tracking ID / AWB *"
                value={value}
                onChange={onChange}
                autoFocus
            />
            {errorMsg && (
                <p className="error-text">{errorMsg}</p>
            )}
            <button type="submit" className="track-btn" disabled={loading}>
                {loading ? "Loading..." : "TRACK YOUR ORDER"}
            </button>
        </form>
    );
}

export default TrackForm;
